import { styled, Table } from '@mui/material';

export const StyledTable = styled(Table)(({ theme }) => ({
  overflow: 'hidden',
  borderCollapse: 'unset',
  'th:nth-child(1)': {
    borderRadius: '10px 0px 0px 10px',
    overflow: 'hidden',
  },
  'th:nth-last-child(1)': {
    borderRadius: '0px 10px 10px 0px',
    overflow: 'hidden',
  },
  '& .MuiTableCell-root': {
    borderBottom: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiTableCell-root': {
      padding: '5px 8px',
    },
  },
}));
